document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
            const observer = new MutationObserver(() => {
                if (window.BSS_BCP?.netterm?.showButtonOnCartPage && !document.querySelector('.bss-b2b-customer-portal-nt-checkout-btn')) {
                    window.BSS_BCP.netterm.showButtonOnCartPage();
                }
            });

            observer.observe(cartDrawer, { attributes: true });
        }
    }, 1000);
});
